import React from 'react'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import Table from 'components/Table'
import TextInput from 'components/TextInput'

import { SystemComponent } from 'types/SystemComponent'

import { screenSize } from 'styles/shared'

export type Props = {
    content: Required<SystemComponent>
    errorMessage: string
    loading: boolean
    isDeleting: boolean
    onChangeCallBack: (arg0: Partial<SystemComponent>) => void
    onCancelCallBack: () => void
    onDeleteCallBack: () => void
    onSaveCallBack: () => void
    showSpinner?: boolean
}

const EditableComponent = ({ errorMessage = '', loading, isDeleting, content, onChangeCallBack, onCancelCallBack, onDeleteCallBack, onSaveCallBack, showSpinner = false }: Props) => {
  const formButtons = () => {
    return (
      <S.ButtonContainer>
        <S.SubmitContainer>
          <Button decoration="secondary" styles={{ button: { marginRight: 15 } }} text="Cancel" onPress={onCancelCallBack} />
          <Button decoration="positive" styles={{ button: { marginRight: 5 } }} enabled={!loading} text="Save" onPress={onSaveCallBack} showSpinner={showSpinner && !isDeleting} />
        </S.SubmitContainer>
        { content.id
          ? <Button decoration="danger" enabled={!isDeleting} text="Delete" onPress={onDeleteCallBack} showSpinner={showSpinner && isDeleting} /> : <></>
        }
      </S.ButtonContainer>
    )
  }

  return (
    <>
      <S.Cell>
        <S.Input autoFocus type="text" placeholder="description" value={content.description} onChange={(e) => onChangeCallBack({ description: e.target.value })} />
      </S.Cell>
      <S.Cell>
        <S.Input type="text" placeholder="model number (required)" errorMessage={errorMessage || ''} value={content.modelNumber} onChange={(e) => onChangeCallBack({ modelNumber: e.target.value })} />
      </S.Cell>
      <S.Cell>
        <S.Input type="text" placeholder="serial number" value={content.serialNumber} onChange={(e) => onChangeCallBack({ serialNumber: e.target.value })} />
      </S.Cell>
      <S.Cell>
        <S.Input type="text" placeholder="version number" value={content.versionNumber} onChange={(e) => onChangeCallBack({ versionNumber: e.target.value })} />
      </S.Cell>
      <S.FormButtonsCell>
        {formButtons()}
      </S.FormButtonsCell>
    </>
  )
}

export default EditableComponent

const Cell = styled(Table.Cell)`
  padding: 0 2px 0 15px;

  @media ${screenSize.small} {
    padding: 5px 15px;
  }

  > div {
    margin-bottom: 0;
    width: 100%;
  }
`

const S = {
  Cell: styled(Cell)``,
  FormButtonsCell: styled(Cell)`
    flex-grow: 2;
    padding-right: 15px;
  `,
  Input: styled(TextInput)`
    > input:first-of-type {
      border-radius: 4px;
      height: 35px;
    }
  `,
  ButtonContainer: styled.div`
    align-items: start;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  `,
  SubmitContainer: styled.div`
    margin-right: 10px;
    margin-bottom: 2px;
    display: flex;
  `
}
